<template>
  <div>
    <button
      ref="highlightButton"
      v-tooltip.top="`Highlight text`"
      class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white transition-colors duration-200"
      :style="{ backgroundColor: activeColor }"
      :class="{ 'bg-gray-100': colorPickerPanel?.isOpen }"
      aria-label="Highlight text"
      @click="toggleColorPicker"
    >
      <Icon
        class="h-[20px] w-[20px]"
        name="material-symbols-light:format-ink-highlighter"
      />
    </button>

    <OverlayPanel
      ref="colorPickerPanel"
      :dismissable="true"
      :show-close-icon="false"
      class="p-3"
    >
      <div class="grid grid-cols-3 gap-2">
        <button
          v-for="color in colors"
          :key="color.name"
          :class="[
            'w-8 h-8  border-2 cursor-pointer hover:scale-110 transition-transform',
            'border-gray-300',
            { 'border-gray-800': isActiveColor(color.value) },
          ]"
          :style="{ backgroundColor: color.value }"
          :title="color.name"
          @click="selectColor(color.value)"
        />
      </div>

      <div class="mt-2 pt-2 border-t border-gray-200">
        <button
          class="w-full text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 px-2 py-1 rounded"
          @click="removeHighlight"
        >
          Remove Highlight
        </button>
      </div>
    </OverlayPanel>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { Editor } from '@tiptap/vue-3'

const editor = defineModel<Editor>('editor')

const highlightButton = ref()
const colorPickerPanel = ref()

const colors = [
  { name: 'Yellow', value: '#FFFFA1' },
  { name: 'Orange', value: '#FFE5CC' },
  { name: 'Red', value: '#FFD6D6' },
  { name: 'Pink', value: '#FFE1F0' },
  { name: 'Purple', value: '#E6D6FF' },
  { name: 'Blue', value: '#CCE5FF' },
  { name: 'Cyan', value: '#CCFFFF' },
  { name: 'Green', value: '#D6FFD6' },
  { name: 'Gray', value: '#E6E6E6' },
]

const toggleColorPicker = (event: Event) => {
  colorPickerPanel.value?.toggle(event, highlightButton.value)
}

const selectColor = (color: string) => {
  console.log('selectColor', color)
  editor.value?.chain().focus().toggleHighlight({ color: color }).run()

  colorPickerPanel.value?.hide()
}

const removeHighlight = () => {
  editor.value?.chain().focus().unsetHighlight().run()
  colorPickerPanel.value?.hide()
}

const isActiveColor = (color: string) => {
  return editor.value?.getAttributes('highlight').color === color
}

const activeColor = computed(() => {
  return editor.value?.getAttributes('highlight').color || ''
})
</script>
